import request from './adminRequest'

const employeeApi = {
  listEmployee (params) {
    return request.get('/employees', {params: params})
  },
  getEmployee (id) {
    return request.get('/employees/' + id)
  },
  createEmployee (data) {
    return request.post('/employees/', data)
  },
  updateEmployee (id, data) {
    return request.put('/employees/' + id, data)
  },
  deleteEmployee (name) {
    return request.delete('/employees/' + name)
  },
  listEmployeePermissions (id) {
    return request.get('/employees/' + id + '/permissions')
  },
  listEmployeeRoles (id) {
    return request.get('/employees/' + id + '/roles')
  },
  assignRoles (data) {
    return request.post('/employees/assignRoles', data)
  },
  assignLibaUid (data) {
    return request.post('/employees/assignLibaUid', data)
  },
  removeLibaUid (data) {
    return request.post('/employees/removeLibaUid', data)
  },
  resetPassword (data) {
    return request.put('/employees/resetPassword', data)
  },
}
export default employeeApi
